import { useEffect, useState } from 'react'
import walletIcon from '../Assets/icons/walletIcon.svg'
import points from '../Assets/icons/threepoints.svg'
import arrowUp from '../Assets/icons/arrowUp.svg'
import arrowDown from '../Assets/icons/arrowDown.svg'
import Chart from 'react-apexcharts'
import axiosInstance from '../Services/Api'
import { useAuth } from '../Contexts/AuthContext'

const WalletComponent = () => {
    const { chartData,getUserdata } = useAuth()
    const [filter, setFilter] = useState('total');
    const [userData, setUserData] = useState(); // Estado para armazenar os dados do usuário

    const getUserData = async (filter) => {
        try {
            const response = await axiosInstance.get('/api/getUserData', {
                params: { filter } // Passa o filtro como parâmetro de consulta
            });
            if (response.data.status === 0 && window.location.hash !== '#/profile') {
                window.location.href = '/#/configuracoes';
              }
            setUserData(response.data); // Atualiza o estado com os dados recebidos
        } catch (e) {
            if (e.response && e.response.status === 401) { 
                window.localStorage.removeItem('token');
                window.location.reload();
              }
              console.error("Erro ao buscar dados do usuário:", e);
        }
    };
    useEffect(() => {
        getUserData(filter); 
        getUserdata();// Passa o filtro para a função de obtenção de dados
        const interval = setInterval(() => { getUserdata();getUserData(filter); }, 10000);
        return () => clearInterval(interval); // Limpa o intervalo ao desmontar
    }, [filter]); // Dependência do filtro

    if (userData == null || !chartData) {
        return (
            <div className="flex justify-center h-screen items-center mt-8">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-500"></div>
            </div>
        );
    }

    return (
        <div className='w-full bg-[#171717]'>
            <div className="flex w-full md:w-[30%] text-[12px] mt-4 justify-between mb-4">
                <button onClick={() => setFilter('estaSemana')} className={`p-2 rounded-[20px]  ${filter === 'estaSemana' ? 'bg-[#478DF8]' : 'bg-[transparent] border'}`}>Esta Semana</button>
                <button onClick={() => setFilter('esteDia')} className={`p-2 rounded-[20px]  ${filter === 'esteDia' ? 'bg-[#478DF8]' : 'bg-[transparent] border'}`}>Este Dia</button>
                <button onClick={() => setFilter('ultimos7dias')} className={`p-2 rounded-[20px]  ${filter === 'ultimos7dias' ? 'bg-[#478DF8]' : 'bg-[transparent] border'}`}>Últimos 7 Dias</button>
                <button onClick={() => setFilter('total')} className={`p-2 px-4 rounded-[20px]  ${filter === 'total' ? 'bg-[#478DF8]' : 'bg-[transparent] border'}`}>Total</button>
            </div>
            <div className="w-full mt-4 gap-4 grid md:grid-cols-4">
                <div className="w-full p-4 border rounded-[10px] border-[#343B4F]">
                    <div className='flex w-full justify-between'>
                        <div className='flex text-[13px] text-[#AEB9E1] gap-1'>
                            <img src={walletIcon} />
                            <p>Depósitos gerados</p>
                        </div>
                        <img src={points} />
                    </div>
                    <div className='flex gap-2 mt-4 items-center'>
                        <p className='text-[20px]'>R$ {userData.faturamento}</p>
                        <div className={`rounded-[5px] text-[10px] items-center flex px-1 flex-shrink h-[80%] py-1 ${userData.crescimentoFaturamento < 100
                            ? 'text-[#FF5A65] bg-[#FF5A652D]'  // Se o crescimento for menor que 100
                            : 'text-[#14CA74] bg-[#14CA742D]'  // Se o crescimento for maior ou igual a 100
                            }`}>
                            {userData.crescimentoFaturamento}%
                        </div>
                    </div>
                </div>
                <div className="w-full p-4 border rounded-[10px] border-[#343B4F]">
                    <div className='flex w-full justify-between'>
                        <div className='flex text-[13px] text-[#AEB9E1] gap-1'>
                            <img src={walletIcon} />
                            <p>Saldo disponível</p>
                        </div>
                        <img src={points} />
                    </div>
                    <div className='flex gap-2 mt-4 items-center'>
                        <p className='text-[20px]'>R$ {userData.balance}</p>
                        <div className={`rounded-[5px] text-[10px] items-center flex px-1 flex-shrink h-[80%] py-1 ${userData.crescimentoSaldo < 100
                            ? 'text-[#FF5A65] bg-[#FF5A652D]'  // Se o crescimento for menor que 100
                            : 'text-[#14CA74] bg-[#14CA742D]'  // Se o crescimento for maior ou igual a 100
                            }`}>
                            {userData.crescimentoSaldo}%
                        </div>
                    </div>
                </div>
                <div className="w-full p-4 border rounded-[10px] border-[#343B4F]">
                    <div className='flex w-full justify-between'>
                        <div className='flex text-[13px] text-[#AEB9E1] gap-1'>
                            <img src={walletIcon} />
                            <p>Saldo Total</p>
                        </div>
                        <img src={points} />
                    </div>
                    <div className='flex gap-2 mt-4 items-center'>
                        <p className='text-[20px]'>R$ {userData.balanceTotal}</p>
                        <div className={`rounded-[5px] text-[10px] items-center flex px-1 flex-shrink h-[80%] py-1 ${userData.crescimentoSaldo < 100
                            ? 'text-[#FF5A65] bg-[#FF5A652D]'  // Se o crescimento for menor que 100
                            : 'text-[#14CA74] bg-[#14CA742D]'  // Se o crescimento for maior ou igual a 100
                            }`}>
                            {userData.crescimentoSaldo}%
                        </div>
                    </div>
                </div>
                <div className="w-full p-4 border rounded-[10px] border-[#343B4F]">
                    <div className='flex w-full justify-between'>
                        <div className='flex text-[13px] text-[#AEB9E1] gap-1'>
                            <img src={walletIcon} />
                            <p>Ticket médio</p>
                        </div>
                        <img src={points} />
                    </div>
                    <div className='flex gap-2 mt-4 items-center'>
                        <p className='text-[20px]'>R$ {userData.ticketMedio.toFixed(2)}</p>
                        <div className={`rounded-[5px] text-[10px] items-center flex px-1 flex-shrink h-[80%] py-1 ${userData.crescimentoTicketMedio < 100
                            ? 'text-[#FF5A65] bg-[#FF5A652D]'  // Se o crescimento for menor que 100
                            : 'text-[#14CA74] bg-[#14CA742D]'  // Se o crescimento for maior ou igual a 100
                            }`}>
                            {userData.crescimentoTicketMedio}%
                        </div>
                    </div>
                </div>
                <div className="w-full p-4 border rounded-[10px] border-[#343B4F]">
                    <div className='flex w-full justify-between'>
                        <div className='flex text-[13px] text-[#AEB9E1] gap-1'>
                            <img src={walletIcon} />
                            <p>Quantidade de transações</p>
                        </div>
                        <img src={points} />
                    </div>
                    <div className='flex gap-2 mt-4 items-center'>
                        <p className='text-[20px]'>{userData.quantidadeTransaction}</p>
                        <div className={`rounded-[5px] text-[10px] items-center flex px-1 flex-shrink h-[80%] py-1 ${userData.crescimentoQuatidade24h < 100
                            ? 'text-[#FF5A65] bg-[#FF5A652D]'  // Se o crescimento for menor que 100
                            : 'text-[#14CA74] bg-[#14CA742D]'  // Se o crescimento for maior ou igual a 100
                            }`}>
                            {userData.crescimentoQuatidade24h}%
                        </div>
                    </div>
                </div>
                {userData.referenceCode && (
                    <div className="w-full p-4 border rounded-[10px] border-[#343B4F]">
                        <div className='flex w-full justify-between'>
                            <div className='flex text-[13px] text-[#AEB9E1] gap-1'>
                                <img src={walletIcon} alt="Wallet Icon" />
                                <p>Saldo afiliado</p>
                            </div>
                            <img src={points} alt="Points" />
                        </div>
                        <div className='flex gap-2 mt-4 items-center'>
                            <p className='text-[20px]'>{userData.affBalance}</p>
                        </div>
                    </div>
                )}
                {userData.referenceCode && (
                    <div className="w-full p-4 border rounded-[10px] border-[#343B4F]">
                        <div className='flex w-full justify-between'>
                            <div className='flex text-[13px] text-[#AEB9E1] gap-1'>
                                <img src={walletIcon} alt="Wallet Icon" />
                                <p>Saldo afiliado Total</p>
                            </div>
                            <img src={points} alt="Points" />
                        </div>
                        <div className='flex gap-2 mt-4 items-center'>
                            <p className='text-[20px]'>{userData.affBalanceTotal}</p>
                        </div>
                    </div>
                )}
            </div>
            <div className="w-full border rounded-[10px] border-[#343B4F] p-4 mt-4">
                <div className='w-full flex justify-between'>
                    <div className='flex items-center text-[14px] gap-2'>
                        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.93128 0.55957C5.74459 0.55957 4.58455 0.911464 3.59786 1.57075C2.61116 2.23004 1.84213 3.16711 1.388 4.26347C0.933874 5.35983 0.815054 6.56623 1.04657 7.73011C1.27808 8.894 1.84952 9.96309 2.68864 10.8022C3.52775 11.6413 4.59685 12.2128 5.76073 12.4443C6.92462 12.6758 8.13102 12.557 9.22738 12.1028C10.3237 11.6487 11.2608 10.8797 11.9201 9.89299C12.5794 8.90629 12.9313 7.74626 12.9313 6.55957C12.9282 4.96921 12.2951 3.44486 11.1705 2.3203C10.046 1.19574 8.52164 0.56262 6.93128 0.55957ZM10.162 7.02111H6.93128C6.80887 7.02111 6.69147 6.97248 6.60492 6.88593C6.51836 6.79937 6.46974 6.68198 6.46974 6.55957V3.3288C6.46974 3.20639 6.51836 3.089 6.60492 3.00244C6.69147 2.91589 6.80887 2.86726 6.93128 2.86726C7.05368 2.86726 7.17108 2.91589 7.25763 3.00244C7.34419 3.089 7.39281 3.20639 7.39281 3.3288V6.09803H10.162C10.2845 6.09803 10.4018 6.14666 10.4884 6.23321C10.575 6.31977 10.6236 6.43716 10.6236 6.55957C10.6236 6.68198 10.575 6.79937 10.4884 6.88593C10.4018 6.97248 10.2845 7.02111 10.162 7.02111Z" fill="#AEB9E1" />
                        </svg>
                        <p className='text-[#AEB9E1]'>Total transacionado 7d</p>
                    </div>
                    {/* <div className='p-2 border border-[#343B4F] items-center text-[12px] gap-1 flex rounded-[10px]'>
                        <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.465088" y="1.87891" width="9.06956" height="9.12111" rx="1" stroke="#AEB9E1" stroke-width="0.8" />
                            <path d="M0.465088 4.92719H9.53465V9.99931C9.53465 10.5516 9.08694 10.9993 8.53465 10.9993H1.46509C0.912805 10.9993 0.465088 10.5516 0.465088 9.99931V4.92719Z" fill="#AEB9E1" stroke="#AEB9E1" stroke-width="0.8" />
                            <path d="M7.51587 1V2.65369" stroke="#AEB9E1" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M2.55493 1V2.65369" stroke="#AEB9E1" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <select className='bg-[transparent]'>
                            <option>Ultimos 7 dias</option>
                        </select>
                    </div> */}
                </div>
                <div className='flex items-center gap-1 text-[24px]'>
                    {Object.keys(userData.chartData).length}
                </div>
                <div className='w-full text-black'>
                    {chartData.options && <Chart
                        options={chartData.options}
                        series={chartData.series}
                        type="line"
                        height={150}
                    />}
                </div>
            </div>
            <div className="w-full mb-[20px] md:mb-0 grid gap-2  mt-4 md:grid-cols-2">
                <div className="w-full  gap-2 grid md:grid-cols-2">
                    <div className="border p-4 rounded-[10px] border-[#343B4F]">
                        <div className='flex w-full justify-between'>
                            <div className='flex text-[13px] text-[#AEB9E1] gap-1'>
                                <img src={arrowDown} />
                                <p>Entradas</p>
                            </div>
                            <img src={points} />
                        </div>
                        <div className='flex gap-2 mt-4 items-center'>
                            <p className='text-[20px]'>R$ {userData.lucro}</p>
                            <div className={`rounded-[5px] text-[10px] items-center flex px-1 flex-shrink h-[80%] py-1 ${userData.crescimentoLucro < 100
                                ? 'text-[#FF5A65] bg-[#FF5A652D]'  // Se o crescimento for menor que 100
                                : 'text-[#14CA74] bg-[#14CA742D]'  // Se o crescimento for maior ou igual a 100
                                }`}>
                                {userData.crescimentoLucro}%
                            </div>
                        </div>
                    </div>
                    <div className="border p-4 rounded-[10px] border-[#343B4F]">
                        <div className='flex w-full justify-between'>
                            <div className='flex text-[13px] text-[#AEB9E1] gap-1'>
                                <img src={arrowUp} />
                                <p>Saídas</p>
                            </div>
                            <img src={points} />
                        </div>
                        <div className='flex gap-2 mt-4 items-center'>
                            <p className='text-[20px]'>R$ {userData.saques}</p>
                            <div className='rounded-[5px] text-[10px] items-center flex px-1 flex-shrink h-[80%] py-1 text-[#FF5A65] bg-[#FF5A652D]'>
                                {userData.crescimentoSaques}%
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-full  p-4 border rounded-[10px] border-[#343B4F]">
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.64063 6.73168C5.72141 6.68504 5.78848 6.61796 5.83511 6.53718C5.88174 6.45639 5.90628 6.36476 5.90626 6.27148V1.49023C5.90578 1.40554 5.88506 1.32218 5.84583 1.24712C5.80659 1.17205 5.74998 1.10746 5.6807 1.05872C5.61143 1.00998 5.53151 0.978515 5.44761 0.966941C5.3637 0.955368 5.27824 0.964024 5.19836 0.992188C3.64776 1.54098 2.34377 2.62488 1.5208 4.04905C0.697825 5.47321 0.409849 7.14423 0.708638 8.76172C0.724126 8.84536 0.759472 8.92406 0.811705 8.9912C0.863938 9.05834 0.931529 9.11196 1.00879 9.14754C1.07843 9.1801 1.15439 9.19688 1.23126 9.19668C1.3245 9.19672 1.41611 9.17221 1.49688 9.12562L5.64063 6.73168ZM4.84376 2.29508V5.96469L1.66422 7.79949C1.65626 7.69922 1.65626 7.59828 1.65626 7.5C1.6572 6.42313 1.95528 5.3674 2.51767 4.44906C3.08007 3.53071 3.88497 2.78536 4.84376 2.29508ZM13.4991 4.08141C13.4932 4.06945 13.4872 4.05684 13.4799 4.04488C13.4726 4.03293 13.4666 4.02297 13.4593 4.01234C12.8504 2.97229 11.98 2.10959 10.9347 1.50989C9.88926 0.910199 8.70519 0.594365 7.50001 0.59375C7.35911 0.59375 7.22398 0.649721 7.12436 0.74935C7.02473 0.848978 6.96876 0.984104 6.96876 1.125V7.22309L1.73528 10.2711C1.67455 10.3063 1.6214 10.3532 1.5789 10.4091C1.5364 10.465 1.50539 10.5287 1.48767 10.5966C1.46994 10.6645 1.46586 10.7353 1.47565 10.8048C1.48544 10.8743 1.5089 10.9412 1.54469 11.0016C2.31253 12.3091 3.48934 13.3276 4.89351 13.8999C6.29768 14.4722 7.85116 14.5664 9.31422 14.1681C10.7773 13.7698 12.0686 12.901 12.9889 11.6959C13.9091 10.4908 14.4072 9.01631 14.4063 7.5C14.4078 6.30078 14.095 5.1221 13.4991 4.08141ZM8.03126 1.68016C8.87382 1.75771 9.68951 2.01721 10.422 2.44072C11.1545 2.86424 11.7864 3.44169 12.274 4.1332L8.03126 6.60418V1.68016ZM7.50001 13.3438C6.57259 13.3414 5.65891 13.1194 4.83376 12.696C4.00861 12.2727 3.29544 11.6599 2.75262 10.908L7.75965 7.99207L7.77426 7.98277L12.8059 5.05227C13.2166 5.9426 13.3966 6.92197 13.3295 7.90016C13.2623 8.87835 12.9502 9.82393 12.4217 10.6498C11.8932 11.4757 11.1654 12.1553 10.3053 12.6261C9.44521 13.0969 8.4805 13.3437 7.50001 13.3438Z" fill="#478DF8" />
                    </svg>
                    <p className='text-[12px] text-[#AEB9E1] mt-2'>R$ {Number(userData.faturamento).toFixed(2)} em vendas</p>
                    <div className='w-full text-[12px] items-center text-[#AEB9E1]  flex gap-2'>
                        <div className=' h-[8px] rounded-[10px] w-full bg-[#0B1739] mt-2'>
                            <div
                                className='rounded-[10px]  h-full bg-[#478DF8]'
                                style={{ width: `${(userData.faturamento > 100000) ? 100 : (userData.faturamento / 100000) * 100}%` }}
                            />
                        </div>
                        {userData.faturamento > 100.000 ? 100 : (userData.faturamento / 100.000).toFixed(2)}%
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WalletComponent